var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockWheel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_41660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9791 5.9694H12.3124V4.63607C12.3124 2.79607 10.8191 1.30273 8.97908 1.30273C7.13909 1.30273 5.64575 2.79607 5.64575 4.63607V5.9694H4.97909C4.24575 5.9694 3.64575 6.5694 3.64575 7.30273V13.9694C3.64575 14.7027 4.24575 15.3027 4.97909 15.3027H12.9791C13.7124 15.3027 14.3124 14.7027 14.3124 13.9694V7.30273C14.3124 6.5694 13.7124 5.9694 12.9791 5.9694ZM8.97908 11.9694C8.24575 11.9694 7.64575 11.3694 7.64575 10.6361C7.64575 9.90273 8.24575 9.30273 8.97908 9.30273C9.71242 9.30273 10.3124 9.90273 10.3124 10.6361C10.3124 11.3694 9.71242 11.9694 8.97908 11.9694ZM11.0458 5.9694H6.91242V4.63607C6.91242 3.49607 7.83909 2.5694 8.97908 2.5694C10.1191 2.5694 11.0458 3.49607 11.0458 4.63607V5.9694Z",
    fill: "#5A1B97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_41660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.979126 0.63623)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockWheel);
export default __webpack_public_path__ + "static/media/LockWheel.5a71f09700f056edf61f74af81c75b82.svg";
export { ForwardRef as ReactComponent };